import React from 'react';
import { logClient } from '../lib/clientLog';

// Last line of defence: a render crash used to unmount the whole app (black screen). Now it is
// logged for the bug report and the user gets a reload button instead.
export class ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { error: null }; }
  static getDerivedStateFromError(error) { return { error }; }
  componentDidCatch(error, info) {
    const stack = String(info?.componentStack || '');
    const top = (stack.match(/at ([A-Z][A-Za-z0-9_]+)/) || [])[1] || '';
    logClient('render_crash', { msg: String(error?.message || error).slice(0, 400), stack: String(error?.stack || '').slice(0, 600), component: stack.slice(0, 400),
      path: window.location.pathname, top });
  }
  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="min-h-dvh bg-background text-foreground flex items-center justify-center p-6" data-testid="app-crash-screen">
        <div className="max-w-sm w-full border border-border rounded-sm bg-card p-5 space-y-3">
          <p className="text-sm font-medium">Da ist etwas schiefgelaufen.</p>
          <p className="text-xs text-muted-foreground break-words">{String(this.state.error?.message || this.state.error).slice(0, 300)}</p>
          <p className="text-[11px] text-muted-foreground">Der Fehler wurde lokal protokolliert — bitte über den Bug-Report melden, das Protokoll wird automatisch angehängt.</p>
          <div className="flex gap-2">
            <button onClick={() => window.location.reload()} data-testid="app-crash-reload" className="text-xs bg-primary text-primary-foreground rounded-sm px-3 h-8">Neu laden</button>
            <button onClick={() => { window.location.href = '/'; }} data-testid="app-crash-home" className="text-xs border border-border rounded-sm px-3 h-8">Zur Startseite</button>
          </div>
        </div>
      </div>
    );
  }
}
